import { BIData, FlightSegment, FullBaggageResponse, JsonsData, PassengerBaggage, SRPBaggageRequest } from '@/src/types/flight'
import { Box } from '@mui/material'

import AircraftAmenitiesWrapper from '@/src/components/common/srp/aircraftAmenities'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'

import BaggageDetails from './baggageDetails'
import ChangeFlights from './changeFlights'
import FlightSegmentHeader from './flightDetailsboxHeader'
import FlightInfo from './flightInfo'
import SegmentLine from './SegmentLine'

export interface FlightDetailsProps {
    segment: FlightSegment
    lastSegment: boolean
    jsons: JsonsData
    layOverDuration?: number | undefined
    baggageData: FullBaggageResponse | undefined
    loading: boolean
    error: string | null
    showBaggage?: boolean
    retryCount: number
    handleRetryBaggage: () => void
    maxRetries: number
}

const FlightDetailsBox: React.FC<FlightDetailsProps> = ({
    segment,
    lastSegment,
    jsons,
    layOverDuration,
    baggageData,
    loading,
    error,
    showBaggage,
    retryCount,
    handleRetryBaggage,
    maxRetries
}) => {
    const getPassengerBaggage = (BI: BIData | undefined): PassengerBaggage | null => {
        const deptStr =
            segment.departure.airportCode +
            '_' +
            segment.arrival.airportCode +
            '_' +
            convertDDMMYYYYToISO(segment.departure.date) +
            '_' +
            segment.departure.time
        const cib = BI?.[deptStr]?.bg?.ADT?.cib ? BI[deptStr].bg.ADT.cib : null
        const cab = BI?.[deptStr]?.bg?.ADT?.cab ? BI[deptStr].bg.ADT.cab : null
        return { cib, cab }
    }

    const baggageForSegment = getPassengerBaggage(baggageData?.BI)
    return (
        <Box sx={{}}>
            <FlightSegmentHeader segment={segment} airlineNames={jsons.airline_names} />
            {/* Flight Route Section */}
            <Box sx={{ display: 'flex', position: 'relative' }}>
                <SegmentLine segment={segment} />
                {/* Timeline */}

                {/* Flight Details */}
                <Box sx={{ flex: 1 }}>
                    {/* Departure */}
                    <FlightInfo timeInfo={segment.departure} jsonsAP={jsons.ap} />

                    {/* Flight Duration and Amenities */}
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <AircraftAmenitiesWrapper
                                    airlineCode={segment.ac}
                                    aircraftCode={segment.act}
                                    flightClass={segment.flightClass}
                                />
                            </Box>

                            {showBaggage && (
                                <BaggageDetails 
                                    baggageData={baggageForSegment} 
                                    loading={loading} 
                                    error={error} 
                                    retryCount={retryCount}
                                    handleRetryBaggage={handleRetryBaggage}
                                    maxRetries={maxRetries}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* Arrival */}
                    <FlightInfo timeInfo={segment.arrival} jsonsAP={jsons.ap} />
                </Box>
            </Box>
            {!lastSegment && (
                <ChangeFlights
                    layOverDuration={layOverDuration}
                    layoverAirport={jsons?.ap?.[segment.arrival.airportCode].c}
                />
            )}
        </Box>
    )
}

export default FlightDetailsBox
